import { type Ref, watch } from 'vue';

export async function ensureRef(ref: Ref, method: () => void) {
  if (ref.value != null) {
    method();
  } else {
    watch(ref, () => {
      if (ref.value != null) {
        method();
        stop();
      }
    });
  }
}
